import React from 'react';
import Symbol from '../../../symbol/Symbol';
import { ICON_CHECKBOX_MARKED_CIRCLE, ICON_CLOSE_CIRCLE } from '../../../../icons';
export function AutoCompleteV2DropdownIndicator(props) {
  const {
    isFocused,
    error,
    valid,
    icon
  } = props;
  if (!error && !valid && !icon) {
    return null;
  }
  let path = icon;
  if (valid && !isFocused) {
    path = ICON_CHECKBOX_MARKED_CIRCLE;
  }
  if (error && !isFocused) {
    path = ICON_CLOSE_CIRCLE;
  }
  return /*#__PURE__*/React.createElement(Symbol, {
    size: 18,
    path: path
  });
}
//# sourceMappingURL=AutoCompleteV2DropdownIndicator.js.map